import { render, staticRenderFns } from "./xxsensor.vue?vue&type=template&id=7283014a"
import script from "./xxsensor.vue?vue&type=script&lang=js"
export * from "./xxsensor.vue?vue&type=script&lang=js"
import style0 from "./xxsensor.vue?vue&type=style&index=0&id=7283014a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports